/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `draft` - Szkic
 * * `scheduled` - Zaplanowany
 * * `published` - Opublikowany
 * * `expired` - Zakończony
 * * `archived` - Zarchiwizowany
 * * `cancelled` - Anulowany
 */
export type OperatorPushQuizEffectiveStateEnum = typeof OperatorPushQuizEffectiveStateEnum[keyof typeof OperatorPushQuizEffectiveStateEnum];


export const OperatorPushQuizEffectiveStateEnum = {
  draft: 'draft',
  scheduled: 'scheduled',
  published: 'published',
  expired: 'expired',
  archived: 'archived',
  cancelled: 'cancelled',
} as const;
